module.exports = __webpack_public_path__ + "static/media/logo2.b222a7a2.png";